import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/lib/i18n";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import ChiSiamo from "@/components/ChiSiamo";
import Servizi from "@/components/Servizi";
import PercheSceglierci from "@/components/PercheSceglierci";
import Contatti from "@/components/Contatti";
import Footer from "@/components/Footer";
import { lenisRef } from "@/lib/scroll";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="min-h-screen overflow-x-clip bg-[#0D0E11] font-body text-[#F8FAFC] antialiased">
        <div className="noise-overlay" aria-hidden="true" />
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <ChiSiamo />
          <Servizi />
          <PercheSceglierci />
          <Contatti />
        </main>
        <Footer />
        <Toaster position="top-right" theme="dark" richColors closeButton />
      </div>
    </LanguageProvider>
  );
}
